import * as types from '@/store/mutation-types';

import app from '@/app';

// Utilities
import { addNoScroll, removeNoScroll } from '@/utilities';

// initial state
const state = {
  isSideNavActive: false,
  hasFooter: true
};

// mutations
const mutations = {
  [types.SET_SIDENAV_ACTIVE] (state, bool) {
    state.isSideNavActive = bool;
  },

  [types.SET_FOOTER] (state, bool) {
    state.hasFooter = bool;
  }
};

const actions = {
  openSideNav: ({ commit, dispatch }) => {
    addNoScroll(0);
    app.$overlay.add(() => dispatch('closeSideNav'));
    commit(types.SET_SIDENAV_ACTIVE, true);
  },

  closeSideNav: ({ commit }) => {
    removeNoScroll();
    app.$overlay.remove(); 
    commit(types.SET_SIDENAV_ACTIVE, false);
  },

  setFooterState: ({ commit }, bool) => {
    commit(types.SET_FOOTER, bool);
  }
};

const getters = {
  global (state) {
    return state;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/store/modules/global.js